import styled, { keyframes } from 'styled-components';

const fadeInLeft = keyframes`
  from{
    transform: translateX(-100px);
    opacity: 0;
  }

  to{
    transform: translateX(0);
    opacity: 1;
  }
`;

const fadeInRight = keyframes`
  from{
    transform: translateX(100px);
    opacity: 0;
  }

  to{
    transform: translateX(0);
    opacity: 1;
  }
`;

export const Container = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  column-gap: 32px;

  margin-top: 150px;
  width: 100%;
  max-width: 1024px;

  h2 {
    font-size: 56px;
    max-width: 414px;
    color: ${({ theme }) => theme.text};
    transition: color 0.15s linear;
    line-height: 64px;

    margin-right: auto;
  }

  > div {
    flex: 1 1 400px;
  }

  @media (max-width: 915px) {
    flex-direction: column;

    > div {
      flex: auto;
    }

    h2 {
      max-width: 550px;
    }
  }

  @media (max-width: 650px) {
    margin-top: 54px;

    h2 {
      font-size: 32px;
      max-width: 280px;
      line-height: 40px;

      margin-bottom: 0;
    }
  }
`;

export const Case = styled.div`
  width: 100%;
  max-width: 496px;
  padding: 35px 48px;
  border-radius: 10px;

  :last-child {
    margin-top: 32px;
  }

  h2 + & {
    margin-top: 69px;
    animation: ${fadeInLeft} 0.4s linear;
  }

  background: ${({ theme }) => theme.clientCases.background};
  transition: background 0.15s linear;
  animation: ${fadeInRight} 0.4s linear;

  p {
    font-size: 24px;
    line-height: 32px;
    color: ${({ theme }) => theme.clientCases.text};
    transition: color 0.15s linear;
  }

  @media (max-width: 650px) {
    padding: 20px;

    margin-top: 24px;

    h2 + & {
      margin-top: 0;
    }

    p {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const Author = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  gap: 10px;

  margin-top: 24px;

  p {
    font-size: 12px;
    color: ${({ theme }) => theme.clientCases.text};
    transition: color 0.15s linear;
    font-weight: 500;
    display: block;
    line-height: 16px;
  }

  span {
    font-size: 12px;
    color: ${({ theme }) => theme.clientCases.text};
    transition: color 0.15s linear;
    font-weight: 300;
    display: block;
    line-height: 16px;
  }
`;
